export default __webpack_public_path__ + "static/contact-hero-59346c8514e6449ba41080abc706421a.jpg";